module.exports = __webpack_public_path__ + "static/iphone-1e65c6fddc8bb28190ec76af8f5154ba.jpg";